(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-avatar-landing"] && !Shopify.designMode) return;
  try {
    
  const showAvatarSlide = (gallery, index) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    if (!slides.length) return;
    const selected = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== selected; });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button, i) => {
      button.setAttribute('aria-pressed', String(i === selected));
    });
    const counter = gallery.querySelector('[data-gallery-count]');
    if (counter) counter.textContent = `${selected + 1} / ${slides.length}`;
  };
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-thumb]');
    if (!control) return;
    const gallery = control.closest('[data-avatar-gallery]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const current = slides.findIndex(slide => !slide.hidden);
    let next = current;
    if (control.matches('[data-gallery-prev]')) next--;
    if (control.matches('[data-gallery-next]')) next++;
    if (control.matches('[data-gallery-thumb]')) next = Number(control.dataset.galleryThumb);
    showAvatarSlide(gallery, next);
  });
  const galleryTouches = new WeakMap();
  document.addEventListener('touchstart', (event) => {
    const slides = event.target.closest('[data-gallery-slides]');
    if (slides && event.touches.length === 1) {
      galleryTouches.set(slides, {x: event.touches[0].clientX, y: event.touches[0].clientY});
    }
  }, {passive: true});
  document.addEventListener('touchend', (event) => {
    const slides = event.target.closest('[data-gallery-slides]');
    const start = slides && galleryTouches.get(slides);
    if (!start || !event.changedTouches.length) return;
    galleryTouches.delete(slides);
    const dx = event.changedTouches[0].clientX - start.x;
    const dy = event.changedTouches[0].clientY - start.y;
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
    const gallery = slides.closest('[data-avatar-gallery]');
    const current = [...gallery.querySelectorAll('[data-gallery-slide]')].findIndex(slide => !slide.hidden);
    showAvatarSlide(gallery, current + (dx < 0 ? 1 : -1));
  }, {passive: true});
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-avatar-form]');
    if (!form) return;
    event.preventDefault();
    const section = form.closest('.fh-avatar');
    const button = event.submitter || form.querySelector('[data-submit]');
    const baseOnly = button.hasAttribute('data-base-only');
    const buttons = Array.from(form.querySelectorAll('[data-submit]'));
    const status = form.querySelector(baseOnly ? '[data-base-status]' : '[data-status]');
    const mainId = Number(form.querySelector('[name="id"]').value);
    const mode = form.querySelector('[data-purchase-mode]:checked')?.value;
    const plan = mode === 'subscription' ? form.querySelector('[data-plan-choice]:checked') : null;
    const items = [{id: mainId, quantity: plan ? Number(plan.dataset.quantity) : 1}];
    if (plan) items[0].selling_plan = Number(plan.value);
    let discountedAddons = 0;
    if (!baseOnly) form.querySelectorAll('[data-addon]:checked').forEach(input => {
      const option = input.closest('.fh-avatar__extra').querySelector('[data-addon-option]').selectedOptions[0];
      const item = {id: Number(input.value), quantity: Number(option.dataset.quantity)};
      if (option.value) item.selling_plan = Number(option.value);
      else discountedAddons++;
      items.push(item);
    });
    buttons.forEach(item => { item.disabled = true; });
    status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'The selected products could not be added. Please try again.');
      const code = section.dataset.discountCode;
      if (discountedAddons && code) {
        window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart'));
      } else {
        window.location.assign(root + 'cart');
      }
    } catch (error) {
      status.textContent = error.message || 'Please try again.';
      buttons.forEach(item => { item.disabled = false; });
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-addon-option]')) {
      const card = event.target.closest('.fh-avatar__extra');
      card.querySelector('[data-addon]').checked = true;
      const option = event.target.selectedOptions[0];
      const compare = card.querySelector('[data-addon-compare]');
      compare.hidden = !option.dataset.comparePrice;
      compare.textContent = option.dataset.comparePrice || '';
      card.querySelector('[data-addon-current]').textContent = option.dataset.currentPrice;
      return;
    }
    if (!event.target.matches('[data-plan-choice], [data-purchase-mode]')) return;
    const form = event.target.closest('[data-avatar-form]');
    if (event.target.matches('[data-plan-choice]')) form.querySelector('[data-purchase-mode][value="subscription"]').checked = true;
    const plan = form.querySelector('[data-purchase-mode]:checked')?.value === 'subscription' ? form.querySelector('[data-plan-choice]:checked') : null;
    form.querySelector('[data-selling-plan-input]').value = plan?.value || '';
    form.querySelector('[data-quantity-input]').value = plan?.dataset.quantity || '1';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-landing"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
